import { render, staticRenderFns } from "./SpecialProceduresDictionary.vue?vue&type=template&id=3758cad2&lang=pug&"
import script from "./SpecialProceduresDictionary.vue?vue&type=script&lang=js&"
export * from "./SpecialProceduresDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports